module.exports = __webpack_public_path__ + "img/icons/nested-folder-2-digit-91ad075cc4cfa4bc6d971ba59346666e.svg";